import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import buySteps from "../../buySteps";
import FacilityTypeStep from "../../../../../../../shared/wizard/steps/facilityTypeStep";

interface ISelectionByOwnBuyStep_5 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  onReset: (key: TKeyOfDataWizardBuy[], data: number[]) => void;
}

const SelectionByOwnBuyStep_5 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_4);

    if (data) {
      onReset(["selectedFacilityTypeIds"], [data[0]]);
    }
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_6);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      const dataFiltered = data.filter((id) => id !== selectedId);
      if (dataFiltered) {
        onChange(dataFiltered, "selectedFacilityTypeIds");
      }
    } else {
      if (data && data.length <= 2) {
        onChange([data[0], selectedId], "selectedFacilityTypeIds");
      }
    }
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="repeat"
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_5;
